import React from "react";
import Styled from "./SAPProcessContentStyles";
import { ColorSAP, FONT_FAMILY, Typography } from "../../ontego-ui";

const SAPProcessContent = ({ title, description, image, children }) => {
  return (
    <Styled.Container>
      <Styled.DescAndImage>
        <Styled.ImagePlaceholder>
          {image && (
            <Styled.ImageBg style={{ backgroundImage: `url(${image})` }} />
          )}
          <Typography
            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
            size={32}
            color={ColorSAP.neutral[0]}
            style={{
              position: "absolute",
              bottom: 32,
              left: 32,
              lineHeight: "42px",
              margin: 0,
              maxWidth: 340,
              zIndex: 1
            }}
          >
            {title}
          </Typography>
        </Styled.ImagePlaceholder>
        <Typography
          fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR}
          size={18}
          color={ColorSAP.neutral[100]}
          style={{
            lineHeight: "25px",
            margin: 0
          }}
        >
          {description}
        </Typography>
      </Styled.DescAndImage>
      <Styled.ProcessGrid>{children}</Styled.ProcessGrid>
    </Styled.Container>
  );
};

export { default as SAPProcessContentStyles } from "./SAPProcessContentStyles";
export default React.memo(SAPProcessContent);
